import React, { useMemo } from 'react';
import PropTypes from "prop-types";
import { Modal, Button, noop } from 'rhombus-react';

import { approvalBooleans } from "utils/CreativeActions";

import ConflictsTable from "./ConflictsTable";

import "./OverwriteMultiple.css";

const { isQA, isApproved } = approvalBooleans;

export function generateSuffix({ approval }) {
	if (isQA(approval) || isApproved(approval)) {
		return "Skip";
	}
}

export default function OverwriteMultipleModal(props) {
	const {
		conflicts,

		onConfirmOverwrite,
		onBack,
	} = props;

	const conflictsWithSuffix = useMemo(() => conflicts.map(conflict => ({
		...conflict,
		suffix: generateSuffix(conflict),
	})), [conflicts]);

	function renderContent() {
		return (
			<div className="table-container">
				<p className="error-msg">
					The following creative files already exist in the creative library and will be overwritten. If a creative
					status is “Approved or “In QA” it cannot be overwritten and will be skipped.
				</p>
				<div className="conflicts-table">
					<ConflictsTable conflicts={conflictsWithSuffix} />
				</div>
			</div>
		);
	}

	function renderFooter() {
		return (
			<>
				<Button onClick={onBack} theme="default">Back</Button>
				<Button theme="red" onClick={onConfirmOverwrite}>Confirm Overwrite</Button>
			</>
		);
	}

	let modalProps = {
		type: "modal",
		title: "Confirm Overwriting Creatives",
		allowFullScreen: false,
		setAppTitle: false,
		className: "creative-upload-error-modal overwrite-multiple",
		xClose: false,
		bladeProps: {
			verticallyCenter: true,
			initialFocus: "p", /*
				If we don't set initialFocus to something, it will auto focus one of the preview
				links, which the user might open by accident by hitting enter.

				After the user attempts to upload, this modal may pop up while they're in the middle
				of doing something else, so we set a value here that won't actually focus anything.
			*/
		},
		renderContent,
		renderFooter,
	};

	return <Modal {...modalProps} />;
}

OverwriteMultipleModal.displayName = "OverwriteMultipleModal";

OverwriteMultipleModal.propTypes = {
	conflicts: PropTypes.arrayOf(PropTypes.shape({
		filename: PropTypes.string,
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		approval: PropTypes.string,
	})),

	onConfirmOverwrite: PropTypes.func,
	onBack: PropTypes.func,
};

OverwriteMultipleModal.defaultProps = {
	conflicts: [],

	onConfirmOverwrite: noop,
	onBack: noop,
};
